export default __webpack_public_path__ + "static/media/TeamMembers.f7126aeb.svg";